var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"media-box"},_vm._l((_vm.data),function(item){return _c('li',{key:item.order,on:{"click":function($event){_vm.clickHandle(item)}}},[_c('h-media',{attrs:{"data":item}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }